<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-card>
          <div slot="header">
            Edition d'un tarif<strong></strong>  
          </div>
          <b-row class="form-group">
             <b-col md="6">
              <label for="tarif">Tarifs</label>
              <b-form-input type="text" v-model="tarification.tarif" placeholder="Tarif de l'operation"></b-form-input>
            </b-col>
            <!-- <b-col md="6">
              <label for="grilletarifaire_libelle">Grille Tarifaire</label>
              <b-form-select id="grilletarifaire_libelle" :plain="true" :options="options_grille" v-model="tarification.grilletarifaire_libelle">
              </b-form-select>
            </b-col> -->
          </b-row>
          <b-row class="form-group">
           
            <b-col md="6">
              <label for="montant_min">Montant Minimum</label>
              <b-form-input type="number" min="1" v-model="tarification.montant_min" placeholder="Montant minimum de l'operation"></b-form-input>
            </b-col>
            <b-col md="6">
              <label for="solde">Montant Maximum</label>
              <b-form-input type="number" min="1" v-model="tarification.montant_max" placeholder="Montant maximum de l'operation"></b-form-input>
            </b-col>
          </b-row>    
          <div slot="footer">
            <span v-if="can('tarification-edit')"><b-button type="submit" size="sm" variant="primary" @click.prevent="put()"><i class="fa fa-dot-circle-o"></i> Modifier</b-button></span>
            <b-button type="reset" @click="goBack" size="sm" variant="danger"><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
        </b-card>    
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'tables',
  data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      options : [],
      options_grille : [],
      tarification:{
            grilletarifaire_libelle:'',
            tarif: '',
            montant_min: '',
            montant_max: '',
            _method: 'PUT'
      },
      typeoperation:[],
      serverParams: {
        page:1,
        current_page: 1,
        paginate: 10
      }
    }
  },
  methods:{
      countDownChanged (dismissCountDown) {
          this.dismissCountDown = dismissCountDown
      },
      showAlert () {
        this.dismissCountDown = this.dismissSecs
      },
      goBack() {
        this.$router.go(-1)
      },
      async put(){    
         if((this.tarification.tarif>=0) && (this.tarification.montant_min>=0) && (this.tarification.montant_max>=0)){ 
           if(parseInt(this.tarification.montant_min)<parseInt(this.tarification.montant_max)){
          this.response = await this.$store.dispatch('tarification/put_tarifications',{id:this.$route.params.id,tarification:this.tarification})
          this.showAlert()
           }else{alert('Le montant maximale doit être supérieur au montant minimale')}
        }else{alert('Veuillez saisir des montants supérieurs à zéro.')
        }
      },
      async get_all_grilletarifaires(){
        await this.$store.dispatch('grilletarifaire/get_all_grilletarifaires',this.serverParams).then(()=>{
          return this.grille =  store.getters['grilletarifaire/rows'];
        })
        this.grille.forEach((element)=>{
            this.options_grille.push({
              value:element.libelle,
              text:element.libelle.toUpperCase()
            })
        })
      },
      async displayTarification(){
        let response = await this.$store.dispatch('tarification/show_tarifications',this.$route.params.id)
        this.tarification.grilletarifaire_libelle = response.grilletarifaire_libelle
        this.tarification.tarif= response.tarif,
        this.tarification.montant_min= response.montant_min,
        this.tarification.montant_max= response.montant_max
          //this.tarification.grilletarifaire_libelle= response.grilletarifaire_libelle
      },
      async get_all_typeoperations(){
            await this.$store.dispatch('typeoperation/get_all_typeoperations').then(()=>{
              return this.typeoperation =  store.getters['typeoperation/rows'];
            })
            //this.typeoperation =  store.getters['typeoperation/rows'];
            this.typeoperation.forEach((element)=>{
                this.options.push({
                  value:element.id,
                  text:element.libelle.toUpperCase()
                })
            })
      },
      // get_all_tarifications(){
      //     return this.rows = store.getters['tarification/rows'];
      // },
      can(perm){
            return store.getters['auth/can'](perm)
        },
      reset() {
        this.tarification.tarif= '',
        this.tarification.montant_min= '',
        this.tarification.montant_max= ''
      }
  },
  mounted(){
    //this.get_all_typeoperations()
    this.get_all_grilletarifaires()
    this.displayTarification()
  }
}
</script>
